import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyA4iYUvL5piJ4Tl-FY5iC1XaNm5lIWWAG0",
  authDomain: "paintformulatorstain.firebaseapp.com",
  projectId: "paintformulatorstain",
  storageBucket: "paintformulatorstain.firebasestorage.app",
  messagingSenderId: "1050206241851",
  appId: "1:1050206241851:web:dbebff97d0d109e8b0c81e",
  measurementId: "G-P0612ED5TN"
};


const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);